<div class="page-container" [ngClass]="{ mobile: mobile, 'show-sidebar': showSideBar }">
    <div class="top-nav">
        <div class="icons-container">
            <button mat-icon-button class="menu-button" (click)="showSideBar = !showSideBar">
                <mat-icon class="menu-button-icon">menu</mat-icon>
            </button>
            <h1 class="text">
                {{ environment.projectTitle }} - {{ userType }}
            </h1>
        </div>
        <div class="icons-container">
            <img src="/assets/images/logo-garantor.png" alt="" class="logo">
        </div>
        <div class="icons-container right">
            <span class="hello text">
                Hola! {{ username }}
            </span>
            <button mat-icon-button class="notifications-button menu-button mini" [mat-menu-trigger-for]="notificationsMenu" (click)="getNotifications()" *ngIf="!mobile">
                <mat-icon class="menu-button-icon" [matBadge]="notificationsCount" [matBadgeHidden]="!notificationsCount" matBadgeColor="accent">
                    notifications
                </mat-icon>
            </button>
            <button mat-icon-button matTooltip="Cerrar sesión" class="logout menu-button" (click)="logout()" *ngIf="!mobile">
                <mat-icon class="menu-button-icon">power_settings_new</mat-icon>
            </button>
        </div>
    </div>
    <div class="page-bottom">
        <div class="side-nav">
            <app-side-nav-menu [menu]="menu" *ngFor="let menu of sideNavMenus"></app-side-nav-menu>
            <div class="side-nav-spacing"></div>
            <div class="side-nav-bottom" *ngIf="mobile">
                <button mat-icon-button class="notifications-button menu-button mini" routerLink="/notificaciones">
                    <mat-icon class="menu-button-icon" [matBadge]="notificationsCount" [matBadgeHidden]="!notificationsCount" matBadgeColor="accent">
                        notifications
                    </mat-icon>
                </button>
                <button mat-icon-button matTooltip="Cerrar sesión" class="logout menu-button" (click)="logout()">
                    <mat-icon class="menu-button-icon">power_settings_new</mat-icon>
                </button>
            </div>
        </div>
        <div class="page-content">
            <div class="page-title" *ngIf="titulo">
                <div class="stepper" [style.visibility]="routerSteps.length < 2 ? 'hidden' : 'visible'">
                    <div class="step" *ngFor="let route of routerSteps; let i = index">
                        <span class="step-link" (click)="redirectTo(i)">{{ route }}</span>
                        <mat-icon class="separator">chevron_right</mat-icon>
                    </div>
                </div>
                <h1>{{ titulo }}</h1>
                <h3>{{ descripcion }}</h3>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</div>

<mat-menu #notificationsMenu="matMenu" xPosition="before">
    <div class="notifications-menu" (click)="$event.stopPropagation()">
        <div class="header">
            <div class="title-container">
                <h2 class="title">
                    Inbox
                </h2>
                <app-reload-button (afterReload)="getNotifications()"></app-reload-button>
            </div>
            <a class="view-all link" routerLink="/notificaciones">
                Ver todas
            </a>
        </div>
        <div class="notification-list">
            <div class="notification" *ngFor="let notification of notifications" [ngClass]="{ unread: !notification.fechaLectura }" [routerLink]="'/notificaciones/'+notification.id" [queryParams]="{ returnUrl: router.url }" (click)="notificationsMenu.close.emit()">
                <h3 class="title">
                    {{ notification.titulo }}
                </h3>
                <span class="description">
                    {{ notification.contenido }}
                </span>
            </div>
        </div>
        <div class="empty-message" *ngIf="!notifications?.length">
            Sin notificaciones
        </div>
    </div>
</mat-menu>
